import React, { useEffect, useRef, useState } from "react";
import "./Adminblog.css";

const API_URL = "https://rbuymart.rbhardwaj.com/server/api/admin/blog.php";

export default function AdminBlog() {
  const [isHidden, setIsHidden] = useState(true);
  const [isHiddenTable, setisHiddenTable] = useState(true);

  const [faqList, setFaqList] = useState([{ question: "", answer: "" }]);
  const [posts, setPosts] = useState([]);
  const [file, setFile] = useState(null);

  const [form, setForm] = useState({
    title: "",
    author: "",
    date: "",
    category: "",
    brand: "",
    meta: "",
    image: "",
    content: "",
  });

  const [editForm, setEditForm] = useState(null);
  const editorRef = useRef(null);

  const toggleHidden = () => setIsHidden(!isHidden);
  const toggleHiddentable = () => setisHiddenTable(!isHiddenTable);

  const [rows, setRows] = useState("");
  const [cols, setCols] = useState("");

  /* -------- HELPER: READ AUTH TOKEN FROM LOCALSTORAGE -------- */
  const getAuthToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("admin_token") ||
      localStorage.getItem("access_token") ||
      ""
    );
  };

  /* -------- HELPER: SAFE FETCH HANDLER -------- */
  async function safeFetch(url, options = {}) {
    const response = await fetch(url, options);
    const text = await response.text();
    
    let data = {};
    if (text) {
      try {
        data = JSON.parse(text);
      } catch (e) {
        console.error("Non-JSON Server Output:", text);
        throw new Error("Server returned an unexpected non-JSON response.");
      }
    }

    if (!response.ok) {
      throw new Error(data.message || `HTTP Error ${response.status}`);
    }

    return data;
  }

  /* -------- INSERT TABLE INTO EDITOR -------- */
  const insertTableIntoEditor = () => {
    if (rows <= 0 || cols <= 0) {
      alert("Please enter valid rows & columns.");
      return;
    }

    let html = "<table style='width:100%;border-collapse:collapse;' border='1'>";
    for (let r = 0; r < rows; r++) {
      html += "<tr>";
      for (let c = 0; c < cols; c++) {
        html += "<td style='padding:10px'>&nbsp;</td>";
      }
      html += "</tr>";
    }
    html += "</table>";

    execCmd("insertHTML", html);
    setRows("");
    setCols("");
    setisHiddenTable(true);
  };

  /* -------- FETCH BLOG POSTS -------- */
  useEffect(() => {
    fetchPosts();
  }, []);

  async function fetchPosts() {
    try {
      const data = await safeFetch(API_URL);
      if (Array.isArray(data)) {
        setPosts(data);
      } else if (data && Array.isArray(data.data)) {
        setPosts(data.data);
      } else {
        setPosts([]);
      }
    } catch (err) {
      console.error("Error fetching posts:", err);
    }
  }

  /* -------- IMAGE CONVERSION & UPLOAD -------- */
  const convertToWebP = (file, quality = 0.8) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              reject("WebP conversion failed");
              return;
            }
            const webpFile = new File(
              [blob],
              file.name.replace(/\.(jpg|jpeg|png)$/i, ".webp"),
              { type: "image/webp" },
            );
            resolve(webpFile);
          },
          "image/webp",
          quality,
        );
      };

      img.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select an image first.");
      return;
    }

    const brand = editForm ? editForm.brand : form.brand;
    const uploadURL = "https://rbuymart.rbhardwaj.com/server/api/admin/download-image.php";
    const storeURL = "https://rbuymart.rbhardwaj.com/server/uploads/blogimg/";

    try {
      const webpFile = await convertToWebP(file, 0.8);
      const formData = new FormData();
      formData.append("image", webpFile);

      await safeFetch(uploadURL, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: formData,
      });

      alert(`${brand || "Image"} uploaded successfully!`);
      const imageURL = storeURL + webpFile.name;

      if (editForm) {
        setEditForm({ ...editForm, image: imageURL });
      } else {
        setForm({ ...form, image: imageURL });
      }
    } catch (err) {
      console.error(err);
      alert("Image upload failed");
    }
  };

  /* -------- TEXT EDITOR COMMANDS -------- */
  const execCmd = (command, value = null) => {
    if (editorRef.current) {
      editorRef.current.focus();
      document.execCommand(command, false, value);
    }
  };

  const changeColor = (e) => execCmd("foreColor", e.target.value);
  const changeBgColor = (e) => execCmd("backColor", e.target.value);

  function clearstyle() {
    if (editorRef.current) {
      editorRef.current.querySelectorAll("*").forEach((el) => {
        el.removeAttribute("style");
        el.removeAttribute("class");
        el.removeAttribute("id");
      });
    }
  }

  const handleEditorInput = () => {
    const html = editorRef.current ? editorRef.current.innerHTML : "";
    if (editForm) {
      setEditForm((prev) => ({ ...prev, content: html }));
    } else {
      setForm((prev) => ({ ...prev, content: html }));
    }
  };

  /* -------- FORM INPUT HANDLER -------- */
  function onChange(e) {
    const targetForm = editForm || form;
    const setter = editForm ? setEditForm : setForm;
    setter({ ...targetForm, [e.target.name]: e.target.value });
  }

  const handleImageChange = (e) => {
    const url = e.target.value;
    if (editForm) setEditForm({ ...editForm, image: url });
    else setForm({ ...form, image: url });
  };

  /* -------- SUBMIT FORM (CREATE & UPDATE) -------- */
  async function submitForm(e) {
    e.preventDefault();

    const contentHTML = editorRef.current ? editorRef.current.innerHTML : "";
    const payload = editForm
      ? { ...editForm, content: contentHTML, faq: faqList }
      : { ...form, content: contentHTML, faq: faqList };

    try {
      await safeFetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
        body: JSON.stringify(payload),
      });

      alert(editForm ? "Blog updated successfully" : "Blog created successfully");

      setForm({
        title: "",
        author: "",
        date: "",
        category: "",
        brand: "",
        meta: "",
        image: "",
        content: "",
      });

      setFaqList([{ question: "", answer: "" }]);
      setEditForm(null);

      if (editorRef.current) editorRef.current.innerHTML = "";
      fetchPosts();
    } catch (err) {
      console.error("Error submitting blog:", err);
      alert(err.message);
    }
  }

  /* -------- DELETE BLOG -------- */
  async function deletePost(id) {
    if (!window.confirm("Delete blog ID: " + id + "?")) return;

    try {
      await safeFetch(`${API_URL}?id=${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });

      alert("Blog deleted successfully");
      fetchPosts();
    } catch (err) {
      console.error("Error deleting blog:", err);
      alert(err.message);
    }
  }

  /* -------- EDIT BLOG -------- */
  function startEdit(post) {
    setIsHidden(true);
    setEditForm({ ...post });

    if (editorRef.current) {
      editorRef.current.innerHTML = post.content || "";
    }

    try {
      if (post.faq) {
        setFaqList(typeof post.faq === "string" ? JSON.parse(post.faq) : post.faq);
      }
    } catch {
      setFaqList([{ question: "", answer: "" }]);
    }
  }

  return (
    <div>
      {/* TABLE POPUP */}
      <div style={{ ...styles.container, display: isHiddenTable ? "none" : "block" }}>
        <p onClick={toggleHiddentable} style={styles.closeBtn}>&#x2716;</p>
        <h2 style={styles.heading}>Create Table</h2>
        <div style={styles.controls}>
          <input
            type="number"
            placeholder="Enter rows"
            value={rows}
            onChange={(e) => setRows(e.target.value)}
            style={styles.input}
          />
          <input
            type="number"
            placeholder="Enter columns"
            value={cols}
            onChange={(e) => setCols(e.target.value)}
            style={styles.input}
          />
        </div>
        <button style={styles.button} onClick={insertTableIntoEditor}>
          Insert Table into Editor
        </button>
      </div>

      {/* MAIN FORM */}
      <div style={{ marginBottom: 20 }}>
        <form onSubmit={submitForm}>
          <div>
            <div className="admin-header-tap">
              <h3 style={{ textAlign: "center", color: "black" }}>
                {editForm ? "EDIT BLOG" : "BLOG"}
              </h3>
              <div className="flex-div">
                <button type="button" onClick={toggleHidden} className="btn-view">
                  <i className="material-icons">&#xe051;</i> All Blog
                </button>
                <button type="submit" className="btn-add">
                  <i className="material-icons">&#xe80b;</i> {editForm ? "Update" : "Publish"}
                </button>
              </div>
            </div>

            <div className="adminblogtitle-box">
              <div className="formlabeldiv">
                <input
                  name="title"
                  placeholder="Title"
                  value={editForm ? editForm.title : form.title}
                  onChange={onChange}
                  required
                  style={{ backgroundColor: "white" }}
                />
              </div>
              <div className="formlabeldiv">
                <textarea
                  name="meta"
                  placeholder="Meta Description"
                  value={editForm ? editForm.meta : form.meta}
                  onChange={onChange}
                  style={{ backgroundColor: "white" }}
                />
              </div>
              <div className="input-group">
                <div className="formlabeldiv">
                  <input
                    name="author"
                    placeholder="Author"
                    value={editForm ? editForm.author : form.author}
                    onChange={onChange}
                    required
                    style={{ backgroundColor: "white" }}
                  />
                </div>

                <div className="formlabeldiv">
                  <input
                    type="date"
                    name="date"
                    value={editForm ? editForm.date : form.date}
                    onChange={onChange}
                    style={{ backgroundColor: "white" }}
                  />
                </div>
                <div className="formlabeldiv">
                  <input
                    name="category"
                    placeholder="Category"
                    value={editForm ? editForm.category : form.category}
                    onChange={onChange}
                    style={{ backgroundColor: "white" }}
                  />
                </div>

                <div className="formlabeldiv">
                  <select
                    name="brand"
                    value={editForm ? editForm.brand : form.brand}
                    onChange={onChange}
                    style={{ backgroundColor: "white" }}
                  >
                    <option value="" disabled>Select Brand</option>
                    <option value="rbuymart">rbuymart</option>
                  </select>
                </div>
              </div>

              <div className="input-group">
                <div className="formlabeldiv">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setFile(e.target.files[0])}
                    style={{ backgroundColor: "white" }}
                  />
                </div>
                <div className="formlabeldiv">
                  <input
                    type="url"
                    placeholder="your image url "
                    readOnly
                    onChange={handleImageChange}
                    style={{ backgroundColor: "white" }}
                    value={editForm ? editForm.image : form.image}
                  />
                </div>
              </div>
              <button
                type="button"
                onClick={handleUpload}
                style={{
                  padding: "15px 30px",
                  borderRadius: "10px",
                  background: "var(--main-first-color)",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Upload Image to hosting Server
              </button>
            </div>
          </div>

          {/* EDITOR TOOLBAR */}
          <div className="texteditor-box">
            <div className="toolbar">
              <select
                style={{ width: "100px", backgroundColor: "white" }}
                onChange={(e) => execCmd("formatBlock", e.target.value)}
              >
                <option value="<h1>">H1</option>
                <option value="<h2>">H2</option>
                <option value="<h3>">H3</option>
                <option value="<h4>">H4</option>
                <option value="<h5>">H5</option>
                <option value="<h6>">H6</option>
                <option value="<p>">P</option>
              </select>

              <button type="button" title="Create a table" onClick={toggleHiddentable}>
                <i className="material-icons">&#xe42a;</i>
                <h6>Table</h6>
              </button>

              <button type="button" title="Clear format" onClick={() => execCmd("removeFormat")}>
                <i className="material-icons">&#xe239;</i>
                <h6>Clear Format</h6>
              </button>

              <button
                type="button"
                title="Text size 1-7"
                onClick={() => {
                  const size = prompt("Font Size: 1-7", "3");
                  if (size) execCmd("fontSize", size);
                }}
              >
                <i className="material-icons">&#xe245;</i>
                <h6>Size</h6>
              </button>

              <button type="button" title="Bold" onClick={() => execCmd("bold")}>
                <b>B</b><h6>Bold</h6>
              </button>

              <button type="button" title="Italic" onClick={() => execCmd("italic")}>
                <i>I</i><h6>Italic</h6>
              </button>

              <button type="button" title="Underline" onClick={() => execCmd("underline")}>
                <u>U</u><h6>Underline</h6>
              </button>

              <button type="button" title="Subscript" onClick={() => execCmd("subscript")}>
                X<sub>2</sub><h6>Sub</h6>
              </button>

              <button type="button" title="Superscript" onClick={() => execCmd("superscript")}>
                X<sup>2</sup><h6>Sup</h6>
              </button>

              <button type="button" title="Text color">
                <label style={{ cursor: "pointer" }}>
                  <i className="material-icons">format_color_text</i>
                  <h6>Text Color</h6>
                  <input type="color" onChange={changeColor} style={{ display: "none" }} />
                </label>
              </button>

              <button type="button" title="Background color">
                <label style={{ cursor: "pointer" }}>
                  <i className="material-icons">&#xe23a;</i>
                  <h6>Bg Color</h6>
                  <input type="color" onChange={changeBgColor} style={{ display: "none" }} />
                </label>
              </button>

              <button type="button" title="Align Left" onClick={() => execCmd("justifyLeft")}>
                <i className="material-icons">&#xe236;</i><h6>Left</h6>
              </button>

              <button type="button" title="Align Center" onClick={() => execCmd("justifyCenter")}>
                <i className="material-icons">&#xe234;</i><h6>Center</h6>
              </button>

              <button type="button" title="Align Right" onClick={() => execCmd("justifyRight")}>
                <i className="material-icons">&#xe237;</i><h6>Right</h6>
              </button>

              <button type="button" title="Justify" onClick={() => execCmd("justifyFull")}>
                <i className="material-icons">&#xe235;</i><h6>Justify</h6>
              </button>

              <button type="button" title="Number list" onClick={() => execCmd("insertOrderedList")}>
                <i className="material-icons">&#xe242;</i><h6>Order List</h6>
              </button>

              <button type="button" title="Dotted list" onClick={() => execCmd("insertUnorderedList")}>
                <i className="material-icons">&#xe241;</i><h6>Dotted List</h6>
              </button>

              <button type="button" title="Horizontal line" onClick={() => execCmd("insertHorizontalRule")}>
                &#8212;<h6>Line</h6>
              </button>

              <button
                type="button"
                title="Link"
                onClick={() => {
                  const url = prompt("Enter URL:", "https://");
                  if (url) execCmd("createLink", url);
                }}
              >
                <i className="material-icons">&#xe250;</i><h6>Link</h6>
              </button>

              <button type="button" title="Unlink" onClick={() => execCmd("unlink")}>
                <i className="material-icons">&#xe0db;</i><h6>Unlink</h6>
              </button>

              <button type="button" title="Strike through" onClick={() => execCmd("strikethrough")}>
                <i className="material-icons">&#xe257;</i><h6>Cross</h6>
              </button>

              <button
                type="button"
                title="HTML Code insert"
                onClick={() => {
                  const code = prompt("Enter HTML code:");
                  if (code) execCmd("insertHTML", code);
                }}
              >
                <i className="material-icons">&#xe86f;</i><h6>Code</h6>
              </button>

              <button type="button" title="Clear Styles" onClick={clearstyle}>
                <i className="material-icons">&#xe14e;</i><h6>Clear All Style</h6>
              </button>
            </div>

            {editForm && (
              <button
                type="button"
                style={{
                  margin: "10px auto",
                  background: "yellow",
                  color: "#f00202",
                  padding: "10px",
                  width: "100px",
                  borderRadius: "5px",
                  border: "none",
                  cursor: "pointer",
                  display: "block",
                }}
                onClick={() => {
                  setEditForm(null);
                  if (editorRef.current) editorRef.current.innerHTML = "";
                }}
              >
                Cancel Edit
              </button>
            )}

            <div
              ref={editorRef}
              id="editor"
              contentEditable={true}
              suppressContentEditableWarning={true}
              className="editor-box"
              onInput={handleEditorInput}
            ></div>
          </div>
        </form>
      </div>

      {/* FAQ SECTION */}
      <div style={styles.faqSection}>
        <h2 style={{ marginTop: 20 }}>FAQ Section</h2>
        <br />
        {faqList.map((faq, index) => (
          <div key={`faq-${index}`} className="formlabeldiv" style={styles.faqBox}>
            <input
              placeholder="Question"
              style={{ width: "100%", marginBottom: 5, padding: "10px" }}
              value={faq.question}
              onChange={(e) => {
                const updated = [...faqList];
                updated[index].question = e.target.value;
                setFaqList(updated);
              }}
            />
            <textarea
              placeholder="Answer"
              style={{ width: "100%", padding: "10px" }}
              value={faq.answer}
              onChange={(e) => {
                const updated = [...faqList];
                updated[index].answer = e.target.value;
                setFaqList(updated);
              }}
            />
            <button
              type="button"
              onClick={() => setFaqList(faqList.filter((_, i) => i !== index))}
              style={styles.deleteFaqBtn}
            >
              &#x2716;
            </button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => setFaqList([...faqList, { question: "", answer: "" }])}
          style={styles.addFaqBtn}
        >
          + Add row
        </button>
      </div>

      {/* BLOG LIST MODAL/DRAWER */}
      <div className="bloglistdiv" style={{ display: isHidden ? "none" : "block" }}>
        <p onClick={toggleHidden} style={styles.closeBtn}>&#x2716;</p>
        <h3>All Blogs</h3>
        <br />
        <div className="bloglistbox">
          {posts.length === 0 && <p>No blogs found</p>}
          {posts.map((post) => (
            <div key={post.id} style={styles.postCard}>
              {post.image && <img src={post.image} width="150" alt={post.title} />}
              <h4>{post.title}</h4>
              <p><b>Author:</b> {post.author}</p>
              <p><b>Launch Date:</b> {post.date}</p>
              <div style={{ marginTop: "10px", display: "flex" }}>
                <button type="button" onClick={() => startEdit(post)} style={{ marginRight: "10px", cursor: "pointer" }}>
                  Edit
                </button>
                <button type="button" style={{ background: "red", color: "#fff", cursor: "pointer" }} onClick={() => deletePost(post.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "2100",
    maxWidth: "600px",
    margin: "20px auto",
    padding: "50px",
    background: "#fff",
    borderRadius: "10px",
    width: "100%",
    boxShadow: "1px 1px 100px rgba(0, 0, 0, 0.27)",
  },
  heading: {
    textAlign: "center",
    marginBottom: "20px",
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  input: {
    width: "49%",
    padding: "15px",
    fontSize: "16px",
    border: "1px solid black",
    borderRadius: "5px",
  },
  button: {
    padding: "10px 20px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%",
  },
  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "20px",
    fontSize: "30px",
    cursor: "pointer",
  },
  faqSection: {
    padding: "20px",
    maxWidth: "1000px",
    backgroundColor: "white",
    margin: "0px auto",
    borderRadius: "10px",
  },
  faqBox: {
    marginBottom: 30,
    padding: "10px 15px",
    border: "1px solid #00000069",
    position: "relative",
    borderRadius: "10px",
  },
  deleteFaqBtn: {
    background: "red",
    color: "#fff",
    marginTop: 5,
    padding: "5px 10px",
    border: "none",
    borderRadius: "50%",
    position: "absolute",
    top: "-15px",
    right: "-10px",
    cursor: "pointer",
  },
  addFaqBtn: {
    background: "green",
    color: "#fff",
    padding: "10px 13px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  postCard: {
    border: "1px solid #ccc",
    padding: 10,
    marginBottom: 10,
    borderRadius: "8px",
  },
};